<template>
  <div class="form-row">
    <div class="form-label">{{ info.displayName }}</div>
    <div class="form-contro" v-if="isMobile !== 1">
      <a-date-picker
        :mode="'year'"
        :open="isYearOpen"
        @panelChange="onPanelChange"
        @focus="yearFocus()"
        :format="info.format"
        :class="info.pickerClass"
        v-model="info.model"
        v-if="info.displayDateTimeType === 'YEAR'"
        :disabled="info.disabled"
      />
      <a-month-picker
        @change="onChange"
        :format="info.format"
        :class="info.pickerClass"
        v-model="info.model"
        v-if="info.displayDateTimeType === 'MONTH'"
        :disabled="info.disabled"
      />
      <a-date-picker
        @change="onChange"
        :format="info.format"
        v-model="info.model"
        :class="info.pickerClass"
        :showTime="info.showTime"
        :disabled="info.disabled"
        v-if="
          info.displayDateTimeType === 'DATETIME' ||
            info.displayDateTimeType === 'DATE'
        "
      />
    </div>
    <div class="form-contro form-picker" v-if="isMobile == 1">
      <input
        type="text"
        class="form-input"
        v-model="info.formatValue"
        readonly
        @focus="showAlert()"
        :disabled="info.disabled"
      />
      <span class="icon icontemp spicker" v-if="!info.value"></span>
      <span
        class="icon icontemp clear"
        v-if="info.value"
        @click="info.clearValue()"
      ></span>
    </div>
    <div class="form-error" v-if="info.dirty && info.invalid">
      {{ info.validationMessage }}
    </div>
    <van-popup v-model="show" position="bottom" get-container="body">
      <van-datetime-picker
        :class="info.pickerClass"
        v-model="info.modelDate"
        :type="info.vantType"
        @cancel="hideAlert"
        @confirm="vantChange"
        :disabled="info.disabled"
      >
      </van-datetime-picker>
    </van-popup>
  </div>
</template>

<script>
import { interact } from "fire-wind-water/tools/interact";

export default {
  name: "SDatetime",
  props: {
    info: {}
  },
  data() {
    return {
      isMobile: interact.isMobile,
      show: false,
      model: null,
      isYearOpen: false
    };
  },
  methods: {
    onChange(e) {
      this.info.setValue(e);
    },
    onPanelChange(e) {
      this.info.setValue(e);
      this.isYearOpen = false;
    },
    yearFocus() {
      this.isYearOpen = true;
    },
    showAlert() {
      this.model = this.info.model;
      if (!this.info.model) {
        this.info.model = new Date();
        this.info.modelDate = new Date();
      }
      this.show = true;
    },
    hideAlert() {
      this.info.model = this.model;
      this.show = false;
    },
    vantChange(e) {
      this.info.setValue(e);
      this.show = false;
    }
  },
  created() {}
};
</script>

<style scoped></style>
